<template>
    <ContentOrLoading>
        <div id="confirmacion" v-if="iframe && !loading">
            <iframe class="shadow my-2 bg-white" style="display: block; margin: 0 auto; overflow-y: scroll; overflow-x: hidden;" title="TPV"
                    sandbox="allow-top-navigation allow-scripts allow-same-origin allow-forms" :src="iframe" width="325"
                    height="523" frameborder="0" scrolling="yes" loading="lazy"
            ></iframe>
        </div>
        <FormularioPagoComponent :jet_id="jet_id" @payToken="payToken" v-else-if="!loading" />
    </ContentOrLoading>
</template>

<script>
    import ContentOrLoading from '@/components/backend/components/ContentOrLoading';
    import FormularioPagoComponent from '@/components/frontend/compra/FormularioPagoComponent.vue';

    export default {
        props: ['jet_id', 'tid', 'user_id', 'nueva_alta'],
        data() {
            return {
                iframe: '',
                jetToken: null,
                loading: false,
                error: {
                    102: 'Operación no permitida por tipo de tarjeta',
                    105: 'Crédito insuficiente',
                    108: 'Error en el número de tarjeta',
                    109: 'Error en la fecha de caducidad',
                    110: 'Error en los datos',
                    111: 'Bloque CVC2 incorrecto',
                    133: 'Error al procesar el pago, inténtelo de nuevo'
                }
            }
        },
        methods: {
            payToken(jetToken) {
                this.loading = true;
                this.jetToken = jetToken;

                this.procesarConfirmacionTarjeta();
            },
            procesarConfirmacionTarjeta() {
                const params = {
                    filters: {},
                    jetToken: this.jetToken,
                    tid: this.tid,
                    user_id: this.$route.params.user_id ? this.$route.params.user_id : this.user_id,
                    nueva_alta: this.nueva_alta
                }
                this.$store.dispatch(this.config.getVuexAlias('back.usuarios.procesar-confirmacion-tarjeta'), params).then(res => {
                    if (res.data.response.challengeUrl) {
                        this.iframe = res.data.response.challengeUrl;
                        this.$emit('setActive');
                        this.loading = false;
                    } else if (res.data.response.compraFinalizada) {
                        this.$emit('confirmacionTarjeta');
                    }
                }).catch(error => {
                    this.$toast.error('Ha ocurrido un error');
                });
            }
        },
        components: { FormularioPagoComponent, ContentOrLoading }
    }
</script>